import { DispenseError } from './dispense.js';
/**
 * Lay two or three options out against each other.
 *
 * **Two is the floor because one option is not a comparison**, and three is the ceiling because
 * `DSP-006` says "two or three": a fourth column on a 7 inch tablet at the counter is four columns
 * nobody can read, and the requirement chose the number rather than leaving it open.
 *
 * `otherLinesMinor` is the sum of the non-lens lines already on the order, supplied by the caller
 * because this module has no I/O. Zero is a valid value and means the order is lenses only, which
 * is the ordinary case for a re-glaze.
 */
export function compareLensOptions(options, otherLinesMinor) {
    if (options.length < 2 || options.length > 3) {
        throw new DispenseError(`A comparison is two or three options, not ${String(options.length)} (DSP-006).`);
    }
    const ids = new Set(options.map((o) => o.productId));
    if (ids.size !== options.length) {
        // The same lens twice would show two identical columns and a zero difference, which reads as a
        // real choice between them. It is a caller bug, so it is loud.
        throw new DispenseError('A comparison names each lens once.');
    }
    if (otherLinesMinor < 0n) {
        throw new DispenseError('The other lines on the order cannot sum to less than nothing.');
    }
    const totals = options.map((o) => o.priceMinor + otherLinesMinor);
    // `reduce` over bigint rather than `Math.min`, which would go through a double and lose a unit
    // above 2^53. A rupee is a minor unit here, so that is reachable on a large order.
    const cheapest = totals.reduce((low, t) => (t < low ? t : low), totals[0]);
    return options.map((o, i) => {
        const totalMinor = totals[i];
        return {
            productId: o.productId,
            name: o.name,
            lensMinor: o.priceMinor,
            otherLinesMinor,
            totalMinor,
            deltaFromCheapestMinor: totalMinor - cheapest,
            isCheapest: totalMinor === cheapest,
            warnings: o.warnings,
        };
    });
}
//# sourceMappingURL=lens-comparison.js.map